/**
 * 帮助手册模块配置文件
 * 支持多语言切换
 */
import { deepCloneConfig } from '@/utils/deepCloneConfig'
import { applyPortalZhToRu } from '@/utils/applyPortalZhToRu'
import { L, resolveLocaleImages } from '@/utils/localeAsset'

// 中文配置
const zhCN = {
  help: {
    // Banner
    titleMain1: '帮助',
    titleMain2: '手册',
    title: '帮助手册',
    subtitle: '操作指南,清晰易懂',
    searchPlaceholder: '请输入关键词',
    searchButton: '搜索',

    // 面包屑
    breadcrumb: {
      home: '首页',
      current: '帮助手册'
    },

    // 详情页
    detail: {
      breadcrumb: '帮助手册详情'
    },

    // 分页
    pagination: {
      pageInfo: '共{total}条，每页显示{pageSize}条',
      firstPage: '首页',
      prevPage: '上一页',
      nextPage: '下一页',
      lastPage: '末页'
    },

    // 资源
    assets: {
      bannerBg: L('help/head-bg.png'),
      searchIcon: L('help/search-ico.png')
    }
  }
}

// 英文配置（预留）
const enUS = {
  help: {
    titleMain1: 'Help',
    titleMain2: 'Manual',
    title: 'Help Manual',
    subtitle: 'Quick guide, easy to understand',
    searchPlaceholder: 'Please enter keywords',
    searchButton: 'Search',
    breadcrumb: {
      home: 'Home',
      current: 'Help Manual'
    },
    detail: {
      breadcrumb: 'Help Manual Detail'
    },
    pagination: {
      pageInfo: 'Total {total}, {pageSize} per page',
      firstPage: 'First',
      prevPage: 'Prev',
      nextPage: 'Next',
      lastPage: 'Last'
    },
    assets: {
      bannerBg: L('help/head-bg.png'),
      searchIcon: L('help/search-ico.png')
    }
  }
}

const ruRU = applyPortalZhToRu(deepCloneConfig(zhCN))

/**
 * 获取帮助手册配置
 * @param {String} lang - 语言标识: 'zh-CN' | 'en-US' | 'ru-RU'
 */
export function getHelpConfig(lang = 'zh-CN') {
  let config = zhCN
  if (lang === 'en-US') config = enUS
  else if (lang === 'ru-RU') config = ruRU
  return resolveLocaleImages(config, lang)
}

export default {
  getHelpConfig
}

